import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { Input, notification, Spin } from 'antd';
import { useIntl } from 'react-intl';

import { StyledModal } from 'common/components';
import { Form } from 'common/components';

import { useGlobalModal } from 'hooks';

import { addProductsToNewApl } from 'services/apl';
import messagesProduct from 'i18n/messages/product';

const layoutForm = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const AddToNewAPLModal = ({ selectedItemList }) => {
  const [formInstance] = Form.useForm();
  const intl = useIntl();

  const [loading, setLoading] = useState(false);

  const queryClient = useQueryClient();

  const { MODAL_NAMES, checkModalVisible, closeModal, closeAllModal } =
    useGlobalModal();

  const visibleModal = checkModalVisible(MODAL_NAMES.ADD_TO_NEW_APL);

  const handleSubmitForm = () => {
    formInstance.validateFields().then(() => {
      setLoading(true);
      let params = formInstance.getFieldsValue();
      let productIds =
        selectedItemList &&
        selectedItemList?.length > 0 &&
        selectedItemList.map((val) => val.id);
      params.productIds = productIds;
      addProductsToNewApl(params)
        .then((resp) => {
          if (resp.isSuccess) {
            notification.success({
              message: intl.formatMessage(
                messagesProduct.addProductToNewAPLSuccess
              ),
            });
            queryClient.invalidateQueries({
              queryKey: ['apl'],
            });
            closeAllModal();
          } else {
            notification.error({
              message: resp?.message,
            });
          }
        })
        .catch((error) => {
          notification.error({
            message: error,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const onCancel = () => {
    formInstance.resetFields();
    closeModal(MODAL_NAMES.ADD_TO_NEW_APL);
  };

  const modalProps = {
    title: intl.formatMessage(messagesProduct.addProductToNewAPLLabel),
    bodyStyle: { height: '122px' },
    width: 500,
    destroyOnClose: true,
    visible: visibleModal,
    onCancel: onCancel,
    onOk: handleSubmitForm,
    okButtonProps: { loading: loading },
    cancelButtonProps: { disabled: loading },
    maskClosable: false,
    closable: !loading,
  };

  return (
    <StyledModal {...modalProps}>
      <Spin spinning={loading} tip='Add product(s) to new APL...' size='large'>
        <Form {...layoutForm} form={formInstance} name='formAddProductToNewApl'>
          <Form.Item
            name='aplName'
            label='Name'
            rules={[{ required: true, message: 'Please input APL name' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name='aplDescription' label='Description'>
            <Input />
          </Form.Item>
        </Form>
      </Spin>
    </StyledModal>
  );
};

export default AddToNewAPLModal;
